import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { useClient } from './ClientContext';
export function CTASection() {
  const {
    clientName
  } = useClient();
  const firstName = clientName.split(' ')[0] || 'Tina';
  return <section id="next" className="py-24 md:py-40 px-5 md:px-10 bg-ink text-ivory relative overflow-hidden" data-id="element-72">
      {/* Subtle gold glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-gold/10 blur-3xl pointer-events-none" data-id="element-73" />

      <div className="max-w-4xl mx-auto text-center relative" data-id="element-74">
        <ScrollReveal data-id="element-75">
          <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-8 font-medium" data-id="element-76">
            — Next Step
          </p>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight font-light mb-10" data-id="element-77">
            Shall we begin,
            <br data-id="element-78" />
            <em className="italic text-gold" data-id="element-79">{firstName}?</em>
          </h2>
          <p className="font-serif text-lg md:text-xl text-ivory/80 leading-relaxed font-light max-w-2xl mx-auto mb-12" data-id="element-80">
            If you'd like to move forward, the next step is to confirm the
            Minimum Viable Brand project so the discovery and strategy phase can
            be scheduled in. To secure the reduced ecommerce website rate, this
            will need to be confirmed within 3 days of the proposal date.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.15} data-id="element-81">
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-82">
            <motion.a href="mailto:hello@avy.me?subject=Confirming Brand Proposal" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="group inline-flex items-center gap-4 bg-ivory text-ink pl-7 pr-7 py-5 rounded-full hover:bg-gold transition-colors duration-500" data-id="element-83">
              <span className="text-xs uppercase tracking-[0.2em] font-medium" data-id="element-84">
                Confirm the project
              </span>
              <ArrowUpRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-85" />
            </motion.a>

            <a href="https://wa.me/447365536636" target="_blank" rel="noopener noreferrer" className="text-xs uppercase tracking-[0.2em] text-ivory/70 hover:text-ivory transition-colors px-4 py-3" data-id="element-86">
              or message Avy directly →
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}